// extracted by mini-css-extract-plugin
export var createdDate = "_ia-1";
export var divider = "_ia-2";
export var headerDivider = "_ia-3";
export var messagesCard = "_ia-0";
export var messagesContainer = "_ia-6";
export var messagesContainerWrapper = "_ia-4";
export var showLeftPanelButton = "_ia-8";
export var topButtons = "_ia-7";
export var withPadding = "_ia-5";